export class ApiSunstudyImage {
  /** @property string */
  url

  /** @property string */
  time
}

export class SunstudyImage {
  /** @property string */
  url

  /** @property string */
  time

  /**
   *
   * @param {ApiSunstudyImage} data
   */
  constructor(data) {
    const { url, time } = data;

    this.url = url;
    this.time = time;
  }
}

export class ApiSunstudy {
  /** @property string */
  key

  /** @property number */
  default

  /** @property [string, string] */
  sunrise

  /** @property [string, string] */
  sunset

  /** @property {ApiSunstudyImage[] | undefined} */
  images
}

class SunstudyTime {
  /** @property {string} */
  start
  /** @property {string} */
  stop

  /**
   *
   * @param {[string, string]} data
   */
  constructor(data) {
    const [start, stop] = data;

    this.start = start;
    this.stop = stop;
  }
}

export default class Sunstudy {
  /** @property number */
  id // this is not a part of api response

  /** @property string */
  key // name of the season

  /** @property number */
  default

  /** @property SunstudyTime */
  sunrise

  /** @property SunstudyTime */
  sunset

  /** @property SunstudyImage[] */
  images

  /**
   * @param {ApiSunstudy} data
   */
  constructor(data) {
    const {
      id, key, default: defaults, sunrise, sunset, images = [],
    } = data;

    this.id = id;
    this.key = key;
    this.default = defaults;
    this.sunrise = new SunstudyTime(sunrise);
    this.sunset = new SunstudyTime(sunset);
    this.images = images.map(data => new SunstudyImage(data));
  }
}
